module.exports = __webpack_public_path__ + "static/korobeinikiBeginning-8a3a5d6f1891ec8e1c04f8d2285fad1f.mp3";